export default [
  {
    path: '/settings/sales-model',
    name: 'pageSalesModelList',
    meta: { title: 'page.pageSalesModelList', roles: ['SETTING_SALES_MODEL_VIEW'] },
    component: () => import('@/pages/settings/sales-model'),
  },
]
